module.exports = __webpack_public_path__ + "static/media/iphone_14_silver_pro.7e07d9ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_silver_pro.jpg
// module id = 2135
// module chunks = 0